module.exports = "https://cdn-assessment.mathletics.com/app/108/assets/images/5c349cdc89a076dc39e864bc6cd50059.svg";